import ContainerFlex, { PrintableBodyWrapper } from "components/ContainerFlex";
import * as St from "./styles";
import { hideCpf, moneyMask } from "utils/mask";
import moment from "moment";
import { useAppSelector } from "redux/app/hooks";

const PrintPaymentResumeAntecipation = ({ data }: any) => {
  const {
    cliente: {
      cpf,
      nome,
      valueAntecipationPurchase,
      valueDiscountAntecipationPurchase,
      valuePaymentInvoice,
    },
  } = useAppSelector((state) => state.cliente);

  const dataHora = moment(data?.dataAntecipacao).format("DD/MM/YYYY HH:mm");

  return (
    <PrintableBodyWrapper>
      <ContainerFlex>
        <St.TitleFaturaTextValue>
          Resumo de Solicitação de Antecipação de Compras
        </St.TitleFaturaTextValue>
        <St.SpanTextTitle>
          De posse do seu cartão TeuCard, favor realizar o pagamento no caixa da
          loja com os dados exatos da solicitação
        </St.SpanTextTitle>
        <ContainerFlex marginTop={10} marginBottom={10}>
          <St.SpanTextBold>Atenção:</St.SpanTextBold>
          <St.SpanTextBold>
            O pagamento deve ser realizado no valor exato no caixa da loja. Sem
            arredondar o valor
          </St.SpanTextBold>
        </ContainerFlex>
      </ContainerFlex>
      <St.Dividers />
      <ContainerFlex marginTop={10} gap="5px">
        <ContainerFlex>
          <ContainerFlex row style={{ gap: 3 }}>
            <St.SpanTextTitleBold>CLIENTE:</St.SpanTextTitleBold>{" "}
            <St.SpanTextTitle>{nome?.toUpperCase()}</St.SpanTextTitle>
          </ContainerFlex>
          <ContainerFlex
            marginTop={10}
            row
            style={{ gap: 3 }}
            marginBottom={10}
          >
            <St.SpanTextTitleBold>CPF:</St.SpanTextTitleBold>{" "}
            <St.SpanTextTitle>{hideCpf(cpf || "")}</St.SpanTextTitle>
          </ContainerFlex>
        </ContainerFlex>
      </ContainerFlex>
      <St.Dividers />
      <St.TitleFaturaTextValue style={{ marginBottom: 10 }}>
        Resumo da solicitação
      </St.TitleFaturaTextValue>
      <ContainerFlex marginTop={10} style={{ gap: 8 }} marginBottom={10}>
        <ContainerFlex row>
          <St.SpanTextTitle>Dados da Solicitação:</St.SpanTextTitle>
          <ContainerFlex end align="flex-end">
            <St.SpanTextTitle>{dataHora}</St.SpanTextTitle>
          </ContainerFlex>
        </ContainerFlex>
        <ContainerFlex row>
          <St.SpanTextTitle>Data do Vencimento:</St.SpanTextTitle>
          <ContainerFlex end align="flex-end">
            <St.SpanTextTitle>
              {moment(data?.dataAntecipacao).format("DD/MM/YYYY")}
            </St.SpanTextTitle>
          </ContainerFlex>
        </ContainerFlex>
        <ContainerFlex row>
          <St.SpanTextTitle>Tipo de transação:</St.SpanTextTitle>
          <ContainerFlex end align="flex-end">
            <St.SpanTextTitle>Pagar no caixa da loja</St.SpanTextTitle>
          </ContainerFlex>
        </ContainerFlex>
        <ContainerFlex row>
          <St.SpanTextTitle>Valor informado:</St.SpanTextTitle>
          <ContainerFlex end align="flex-end">
            <St.SpanTextTitle>
              {moneyMask(Number(valuePaymentInvoice))}
            </St.SpanTextTitle>
          </ContainerFlex>
        </ContainerFlex>
        <ContainerFlex row>
          <St.SpanTextTitle>Valor desconto:</St.SpanTextTitle>
          <ContainerFlex end align="flex-end">
            <St.SpanTextTitle>
              {moneyMask(Number(valueDiscountAntecipationPurchase))}
            </St.SpanTextTitle>
          </ContainerFlex>
        </ContainerFlex>
        <ContainerFlex row>
          <St.SpanTextTitleBold>Valor Total a pagar:</St.SpanTextTitleBold>
          <ContainerFlex end align="flex-end">
            <St.SpanTextTitleBold>
              {moneyMask(Number(valueAntecipationPurchase))}
            </St.SpanTextTitleBold>
          </ContainerFlex>
        </ContainerFlex>
      </ContainerFlex>
      <St.Dividers />
    </PrintableBodyWrapper>
  );
};

export default PrintPaymentResumeAntecipation;
